var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiveEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.1 127.8",
    style: {
      enableBackground: "new 0 0 220.1 127.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5e1f9"
    },
    d: "M218.3 127.8V2.9H1.8v124.9h108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ac7f7"
    },
    d: "M218.3 127.8V2.9l-108.2 69L1.8 2.9v124.9h108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7eb3ff"
    },
    d: "M218.3 22.4V2.9l-108.2 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0561fc",
      strokeWidth: 6.8376
    },
    d: "m218.3 2.9-108.2 69L1.8 2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveEmailIcon);
export default __webpack_public_path__ + "static/media/receiveEmail-icon.802b27037f9b04b5b130a86f7975c1fe.svg";
export { ForwardRef as ReactComponent };